module.exports = __webpack_public_path__ + "static/media/AkodeRed.2a3225e0.png";